






import { Vue, Component } from 'vue-property-decorator';

@Component
export default class Heading3 extends Vue {}
